import { JoinStrings } from "../../../../../utils/dataValidations"
import { formatDateNumberWithTime } from "../../../../../utils/dateFormat"

const CuadernoHistorialVentaDetail = ({ detail = {} }) => {
    return (
        <div className="grid grid-cols-2 text-gray-900 dark:text-gray-200 gap-2 text-sm">
            {
                [
                    { label: 'Vendido a', value: JoinStrings([detail?.user_nombres, detail?.user_apellido_paterno, detail?.user_apellido_materno], ' ') },
                    { label: 'Producto', value: detail?.producto_nombre },
                    { label: 'Intercambio', value: detail?.metodo_intercambio, },
                    { label: 'Tipo', value: detail?.tipo, },
                    { label: 'Fecha de registro', value: formatDateNumberWithTime(detail?.createdAt), },
                    { label: 'Cantidad', value: detail?.cantidad, },
                    { label: 'Cantidad recojido', value: detail?.cantidad_retorno, },
                    { label: 'Cantidad deuda', value: detail?.cantidad_deuda, },
                    { label: 'Pago', value: detail?.metodo_pago, },
                    { label: 'Precio unitario Bs.', value: detail?.precio_unitario, },
                    { label: 'Venta Bs.', value: detail?.venta_total, },
                    { label: 'Efectivo Bs.', value: detail?.efectivo_total, },
                    { label: 'Transferencia Bs.', value: detail?.transferencia_total, },
                    { label: 'Saldo Bs.', value: detail?.deuda_total, },
                    { label: 'Garantía Efectivo Bs.', value: detail?.monto_garantia_string, },
                    { label: 'Garantía Transferencia Bs.', value: detail?.monto_garantia_transferencia_string, },
                    { label: 'Encargado', value: detail?.encargado ?? '-', },
                    { label: 'Observaciones', value: detail?.obs ?? '-', },
                ].map((i, index) => (
                    <div key={index} className="flex gap-2 font-semibold col-span-2 sm:col-span-1">
                        <span className="bg-gray-200 dark:bg-gray-700 p-2 rounded-md shadow-md">{i.label}</span>
                        <span className="bg-yellow-100 dark:bg-yellow-700 p-2 rounded-md shadow-md">{i.value}</span>
                    </div>
                ))
            }
        </div>
    )
}

export default CuadernoHistorialVentaDetail